import script from "./distributor-select.vue?vue&type=script&lang=ts&setup=true"
export * from "./distributor-select.vue?vue&type=script&lang=ts&setup=true"

import "./distributor-select.vue?vue&type=style&index=0&id=17c86194&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17c86194"]])

export default __exports__